<!-- Retour Button -->
<div class=" retour" (click)="onGoBack()" style="margin-bottom: 29px ; margin-left: 23px; margin-top: 24px">
    <i style="font-size: 20px; ">←</i>
    <strong>Retour</strong>
</div>

<div class="wizard-sidebar p-0" [style.--progress]="getProgress() + '%'" style="margin-left: 55px;">
    <ul class="list-unstyled steps-container">
        <li *ngFor="let step of steps; let i = index" class="step-item"
            [ngClass]="{'completed': i < currentStep}">
            <div class="d-flex align-items-center position-relative step-item">
                <div
                        class="step-circle-container"
                        [ngClass]="{  'completed': i < currentStep,  'current': i === currentStep,'inactive': i > currentStep}"
                        [class.clickable]="i <= currentStep">
                    <div class="step-circle"></div>
                    <div *ngIf="i < currentStep" class="check-container">
                        <span data-feather="check" class="check-icon"></span>
                    </div>
                </div>

                <div class="step-label" [class.fw-bold]="i === currentStep">
                    <span class="step-text">{{ num(i) }}. {{ step }}</span>
                </div>

                <div *ngIf="i < steps.length - 1" class="step-connector"></div>
            </div>
            <!-- Remove the line from the last step and apply blue color for completed steps -->
            <div *ngIf="i < steps.length - 1" class="line" [ngClass]="{'completed-line': i < currentStep}"></div>
        </li>
    </ul>
</div>
